import apiClient from './apiClient';

// ── Attendance ────────────────────────────────────────────────────────────────
export const attendanceService = {
  get: (employeeId, month, year) =>
    apiClient.get('/api/attendance', { params: { employeeId, month, year } }).then((r) => r.data),

  save: (data) =>
    apiClient.post('/api/attendance', data).then((r) => r.data),

  monthSummary: (month, year) =>
    apiClient.get('/api/attendance/summary', { params: { month, year } }).then((r) => r.data),
   getEmployeesWithAttendance: (month, year) =>
    apiClient.get('/api/attendance/employees-with-attendance', { params: { month, year } }).then(r => r.data),
};

// ── Payroll ───────────────────────────────────────────────────────────────────
export const payrollService = {
  list: (params) =>
    apiClient.get('/api/payroll', { params }).then((r) => r.data),

  getOne: (id) =>
    apiClient.get(`/api/payroll/${id}`).then((r) => r.data),

  calculate: (data) =>
    apiClient.post('/api/payroll/calculate', data).then((r) => r.data),

  run: (data) =>
    apiClient.post('/api/payroll/run', data).then((r) => r.data),

  approve: (id) =>
    apiClient.patch(`/api/payroll/${id}/approve`).then((r) => r.data),

  markPaid: (id) =>
    apiClient.patch(`/api/payroll/${id}/paid`).then((r) => r.data),
};

// ── Advances ──────────────────────────────────────────────────────────────────
export const advanceService = {
  list: (params) =>
    apiClient.get('/api/advances', { params }).then((r) => r.data),

  create: (data) =>
    apiClient.post('/api/advances', data).then((r) => r.data),

  waive: (id) =>
    apiClient.patch(`/api/advances/${id}/waive`).then((r) => r.data),
};

// ── Reports ───────────────────────────────────────────────────────────────────
export const reportService = {
  dashboard: () =>
    apiClient.get('/api/reports/dashboard').then((r) => r.data),

  trend: (months) =>
    apiClient.get('/api/reports/trend', { params: { months } }).then((r) => r.data),

  ytd: (year) =>
    apiClient.get('/api/reports/ytd', { params: { year } }).then((r) => r.data),

  departments: (month, year) =>
    apiClient.get('/api/reports/departments', { params: { month, year } }).then((r) => r.data),
};